import Box from '@mui/material/Box';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IConsultant, saveNewConsultant } from 'wisestep-api';
import { FormWizard } from 'wisestep-base';

import { emptyConsultant } from '../../../helper/EmptyConsultant';

import OwnerInfo from './OwnerInfo';
import PrimaryInfo from './PrimaryInfo';
import SecondaryInfo from './SecondaryInfo';

const AddConsultantForm = () => {
  const [consultant, setConsultant] = useState(emptyConsultant.consultants[0]);
  const navigate = useNavigate();

  const addConsultantInfo = (data) => {
    Object.keys(data).forEach((key) => (data[key] === undefined ? delete data[key] : {}));
    if (data) {
      setConsultant((prev) => ({ ...prev, ...data }));
    }
  };

  const newConsultantObject = (
    emptyConsultant: {
      consultants: IConsultant[];
    },
    consultant: IConsultant
  ) => {
    const newConsultant = emptyConsultant;
    for (const key in consultant) {
      newConsultant.consultants[0][key] = consultant[key];
    }

    return newConsultant;
  };

  const createNewConsultant = async () => {
    try {
      await saveNewConsultant(newConsultantObject(emptyConsultant, consultant));
      navigate('/consultant');
    } catch (e) {
      console.log(e);
    }
  };

  const [currentOption, setCurrentOption] = useState<number>(0);
  const renderForm = () => {
    switch (currentOption) {
      case 0:
        return (
          <PrimaryInfo
            newConsultant={addConsultantInfo}
            setCurrentTab={setCurrentOption}
            consultantData={consultant}
          />
        );
      case 1:
        return <SecondaryInfo newConsultant={addConsultantInfo} setCurrentTab={setCurrentOption} />;
      case 2:
        return (
          <OwnerInfo
            newConsultant={addConsultantInfo}
            setCurrentTab={setCurrentOption}
            postNewConsultant={createNewConsultant}
          />
        );
    }
  };

  return (
    <Box minHeight="100%">
      <FormWizard
        menuItems={[
          {
            id: 0,
            label: 'Primary Info',
            onClick: () => setCurrentOption(0),
          },
          {
            id: 1,
            label: 'Secondary Info',
            onClick: () => setCurrentOption(1),
          },
          {
            id: 2,
            label: 'Owner Info',
            onClick: () => setCurrentOption(2),
          },
        ]}
        currentStep={currentOption}
      >
        <Box pr={4} width="100%" minHeight="100%" ml={3}>
          {renderForm()}
        </Box>
      </FormWizard>
    </Box>
  );
};

export default AddConsultantForm;
